import { combineReducers } from 'redux'
import app from './app'
import signup from './signup'
import freeSignup from './freeSignup'

export default combineReducers({ app, signup, freeSignup })